import React from "react";
import ProductMaintenanceProductSection, { IProductMaintenanceProductSectionProps } from "./ProductMaintenanceProductSection";

const ProductProductWrapper = ({
    product,
    dataGridTableData,
    lookupValues,
    isFormVisible,
    productProductFormikRef,
    updateProductFields,
    setIsChangeProductDetailsForm,
    changeData,
}) => {
 
    const [productMaintenanceData, setProductMaintenanceData] = React.useState<IProductMaintenanceProductSectionProps | null>(null);
    const [initialLoad, setInitialLoad] = React.useState(true);

    React.useEffect(() => {
      if (initialLoad && dataGridTableData) {
        const initialState = {
            product: product,
            dataGridTableData: dataGridTableData,
            lookupValues: lookupValues,
            productProductFormikRef: productProductFormikRef,
            updateProductFields: updateProductFields,
            setIsChangeProductDetailsForm: setIsChangeProductDetailsForm,
            isFormVisible: isFormVisible,
            changeData: changeData,
        }
        setProductMaintenanceData(initialState);

        setInitialLoad(false);
      }
    }, [initialLoad]);

return dataGridTableData && productMaintenanceData?.product ? <ProductMaintenanceProductSection
    product={productMaintenanceData.product}
    dataGridTableData={productMaintenanceData.dataGridTableData}
    lookupValues={productMaintenanceData.lookupValues}
    productProductFormikRef={productMaintenanceData.productProductFormikRef}
    updateProductFields={productMaintenanceData.updateProductFields}
    setIsChangeProductDetailsForm={productMaintenanceData.setIsChangeProductDetailsForm}
    isFormVisible={isFormVisible}
    changeData={productMaintenanceData.changeData}
/> : <></>;

}

export default ProductProductWrapper;